<div #container>
  <app-badge variant="green" class="cursor-pointer" title="In Stock Details">
    <span class="grid grid-cols-[auto_auto] gap-1 justify-items-center">
      <span>{{ data().available }}</span>
      <app-icons icon="garage" svgClass=""/>
    </span>
  </app-badge>

  <app-tooltip [triggerEl]="container" triggerType="click" placement="left">
    <div class="text-left overflow-x-auto">
      <h5 class="text-lg font-bold dark:text-white">In Stock Details</h5>
      <table class="dark">
        <thead>
        <tr>
          <th>On Hand</th>
          <th>Available</th>
          <th>Cost</th>
          <th>Price</th>
        </tr>
        </thead>
        <tbody>
        <tr class="text-right">
          <td>{{ data().total }}</td>
          <td>{{ data().available }}</td>
          <td>{{ data().source.cost | currency }}</td>
          <td>{{ price()(data().source.cost || 0) | currency }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </app-tooltip>
</div>
